import { render, staticRenderFns } from "./Learningrecord.vue?vue&type=template&id=040a2a29&scoped=true"
import script from "./Learningrecord.vue?vue&type=script&lang=js"
export * from "./Learningrecord.vue?vue&type=script&lang=js"
import style0 from "./Learningrecord.vue?vue&type=style&index=0&id=040a2a29&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040a2a29",
  null
  
)

export default component.exports